import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import DownloadApp from "@/components/DownloadApp/DownloadApp";
import ResourcesList from "@/components/Resources/ResourcesList";
import Section from "@/components/Section";
import useResponsive from "@/hooks/useResponsive";
import { Container } from "@mui/material";

const Resources = () => {
  const isDesktop = useResponsive("up", "md");
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <ResourcesList />

      {isDesktop && (
        <Section pt={0} pb={{ md: 12.5, lg: 19 }}>
          <DownloadApp type="secondary" />
        </Section>
      )}
    </>
  );
};

export default Resources;
